import { createContext } from "react";

const ComissionContext = createContext();

export default ComissionContext;
